const swea = require('swea');
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;

class CustomTextLineInteraction extends swea.editor.interactions.TextLineInteraction {
  /**
   * The constructor.
   * @param { object } options An option object, see {@link TextLineInteraction} for more info.
   */
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }
  
  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // When user closes the tool
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
      }
    ));

    // When user wants to remove last point
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.BACK_SPACE],
      this,
      () => {
        this.removeLastPoint();
      }
    ));
  }

  /**
   * When the interaction is initialized open the correct context menu.
   * @param element { DOMElement } The element that the interaction works on
   * @param viewerId { number } The viewerId
   * @override
   */
  whenInitialized(element, viewerId){
    viewerId;
    this._disabledInteractionClasses = swea.editor.InteractionManager.instance().disableContinuousInteractions();
    InstructionServiceActions.showInstruction('instructions.create_line');
  }

  /**
   * Terminates the interaction closing the context menu.
   * @override
   */
  terminate() {
    super.terminate();
    swea.editor.InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    InstructionServiceActions.showInstruction('instructions.corner_interaction');
  }
}
export default CustomTextLineInteraction;
